import { WsDeliverConfigResourceItem, WsDeliverConfigSchemaItem, WsDeliverConfigSchemaMapping, WsDeliverJobInterface, WsDeliverTenantInterface } from "../../../../../core/src/interfaces";
import { encodeResourceName } from "../../../core";
import { WsDeliverConfigItemType, WsDeliverConfigWorkload, WsDeliverTenantStatus } from "../../../enums";




const deliverApplicationString = `Adobe Acrobat Reader 11.0.10
Adobe Flash player active X 10
Adobe SVG Viewer 3.0
Attachmate Application
Business Objects
CA 12.5
Cerebrus
Clarify Application
Crystal reports 2008
Eiger Payment Application
El Guides
Microsoft excel 2007
Filezilla
Fox Delivery Application
IRS
Lawson
Lawson over FTP
Lotus notes 6.5.3
Maginus
Manhattan
MSCD
Microsoft PowerPoint2007
Quick Address Pro
SAP
SAP7.3
SAP73
SpeekKey
TeradataSQL Assistant
Ultima
Ultima Training
Microsoft Visio 2003
Microsoft Word 2007
Xcelcius 2008
Business Objects XI
Cygwin-X and Terminal
Speed Key
Business Objects Web Rich Client
Microsoft Silverlight 5.1
Cyberduck 4.7.1
Attachmate 6.5
Adobe Acrobat 7.07
Microsoft Access 2010
Adobe Acrobat reader 7.0
Microsoft Excel standard 2007
Lotus Notes 6.5
Myriad Application 6.7
Control ERP  5.52
Microsoft Office 2007 Standard
Attachmate
Real Time Proofing
Quick Address Pro 3.02
Digital Evoke
TAPP
SAP 7.3
Monarch
Cognos Controller
Adobe Acrobat Reader XI
Business Objects 12.3
Microsoft Excel 2007 Standard
Lotus notes
SAP MDM 73
POD
Microsoft Powerpoint 2007  Standard
Microsoft Winword 2007 Standard
Witness equaltiy
IBM Cognos Controller 10 .1
Adobe 7
Microsoft Office2007 Standard
Keax
Putty
PVCS
Team Quest
Eclipse
Control M v 8.1
Adrem Remote Console
Toad
TS web Client
Angry IP
Humming Bird
Oracle 92
Star Team
Acqua Data Studio
Command Viewer
DbVisualiser
Intell J Idea
IPScan
Control M 6.4
IBM Websphere
Q Pasa
WinSCp3
IP Scan
Control-M
CiscoMDS9000
Disk Array Manager
Acrobate Reader 7
MS Office 2007
Crystal Reports 10
SQL Server 2000
Microsoft Visual Web Developer 2005 Express Edition
DreamWeaver
Core FTP
Hunning Bird
DbVisualizer
Office 2007
Stores Website
Unicente Remote Desktop
SQL Studio
Text Pad 4
ConsoleOne
MS Access97
CSC Fleet plus 2.5
Business Object
MS Office 2007 Standard
Adobe Acrobat Reader 7
DHL Paragon
Adobe Acrobat
Microsoft Powerpoint 2007
Microsoft Access 2007
Myriad 6.7
Microsoft Office2007
Adobe Acrobat 7.0
Rlog
Lotus Notes Application
Yardsmart
Adobe
CMC Console
Eclipse Menu
Mark Vision
NW Admin
AD Password Reset
Aspect
Avaya CMS Supervisor / apps
Clarify
CognosController10
CTI labs- Dixons Myriad screep pop up
Fire Fox
Log Me In 7.6
Open Span
Oracle client
Adobe Acrobat Reader
Adobe AIR 15.0.0.293
7-Zip File Manager
Access 2010
Access for Business Objects
Ace 7_0
Ace-DevTest 7_0
AceIMACS 7_0
Ace-QA 7_0
Ace-RepairsDM 7_0
Active Directory Users Computers
Adobe Reader
AppCenter
Aptos
Aptos-OneTel UK CGA
ATLAS
BE-SYS-Aptos
Brillo
Business Object 6_5
Business Rules Editor 4_6_1
BusinessObjects 6_5
CAce 7_0
CAce-DevTest 7_0
CACE-QA 7_0
Calculator
CDMi
CDMi Prod
Citrix Session Mgmt Tool
CMP 6 3 10 CPUK LIVE client Apr22
CMP 6 3 9 CPUK LIVE client 180627
CMP-6_3_5-CPUK-LIVE-CLIENT
DataLoad
Desktop Intelligence
Desktop Studio
EdgeSight
EMM 162 ALL
ES-IMS-Aptos-GB
Euro
Excel 2010
Excel 2010_XAW01
File Explorer
FileZilla Client
Finance Excel Addins
FR-SYS-Aptos
Google Chrome
Google Chrome 48
Google Chrome 67
Google Chrome 99
Google Chrome_29
Google_Chrome_59
Google_Chrome_99
Insurance Refund Request-UK
Insurance Refund Request-UK-UAT
JDA Client
Kana Admin v22
Microsoft Excel 2010 Smart
Mozilla Firefox 12
Mozilla Firefox Ver 54
Nimbus_ControlEnterpriseClient 10_4_0
NL-IMS-Aptos
NL-SYS-Aptos
Notepad++
Oracle Object for OLE Class Library Help
Outlook 2010
PLSQL Developer
PLSQL Developer Ora8i
PowerCenter Workflow Monitor 9_6_1 1_0_0_1
PreLaunch-VIA-PRD-XAW
PuTTYgen
Reconciliation
Refunds Backoffice UK - Live Manitoba
Refunds Backoffice-UK - UAT Manitoba
Remedy_18_5
SAP Logon P15 7500 2 15 1153
SAP Logon Patch15
SAP Logon SP15
SAP_Logon_7_5_5_SSO
SE-SYS-Aptos
Snipping Tool
SoapUI_5_3_0
Start eMM
TextPad
UC4_ServiceManager 10
UK-IMS-Aptos
UK-IMS-Aptos QA
UK-SYS-Aptos
UserInterface
VMware vSphere Client 5_1
WinSCP
WinSQL
Word 2010
Word 2010_XAW01
AO Client_Dev
AO Client_Prod
Data Manager_Dev
Data Manager_Prod`;




interface WsDeliverApplication {
  name: string;
}




const getDeliverApplications = (): WsDeliverApplication[] => {

  const list: WsDeliverApplication[] = deliverApplicationString.split(/\r?\n/).map((name: string) => {
    return {
      name
    };
  });

  const sorted: WsDeliverApplication[] = list.sort((a, b) => {
    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    return 0;
  });

  return sorted;
};




export const getWorkloadName = (workload: WsDeliverConfigWorkload) => {

  if (workload === WsDeliverConfigWorkload.Container) {
    return ('DSC');

  } else if (workload === WsDeliverConfigWorkload.EntraId) {
    return ('Entra ID');

  } else if (workload === WsDeliverConfigWorkload.Exchange) {
    return ('Exchange');

  } else if (workload === WsDeliverConfigWorkload.Intune) {
    return ('Intune');

  } else if (workload === WsDeliverConfigWorkload.Office365) {
    return ('Office 365');

  } else if (workload === WsDeliverConfigWorkload.OneDrive) {
    return ('OneDrive');

  } else if (workload === WsDeliverConfigWorkload.Planner) {
    return ('Planner');

  } else if (workload === WsDeliverConfigWorkload.PowerPlatform) {
    return ('Power Platform');

  } else if (workload === WsDeliverConfigWorkload.SecurityCompliance) {
    return ('Security & Compliance');

  } else if (workload === WsDeliverConfigWorkload.SharePoint) {
    return ('SharePoint');

  } else if (workload === WsDeliverConfigWorkload.Teams) {
    return ('Teams');

  } else {
    return `${workload}`;
  }
};




export const getTenantStatus = (tenant: WsDeliverTenantInterface, statusField: string): WsDeliverTenantStatus => {
  if (tenant.fields[statusField]) {
    if (tenant.fields[statusField] === 'COMPLETE') {
      return WsDeliverTenantStatus.Complete;

    } else if (tenant.fields[statusField] === 'IN_PROGRESS') {
      return WsDeliverTenantStatus.InProgress;

    } else if (tenant.fields[statusField] === 'SYNC_IN_PROGRESS') {
      return WsDeliverTenantStatus.SyncInProgress;

    } else if (tenant.fields[statusField] === 'BACKUP_IN_PROGRESS') {
      return WsDeliverTenantStatus.BackupInProgress;

    } else if (tenant.fields[statusField] === 'FAILED') {
      return WsDeliverTenantStatus.Failed;
    } else if (tenant.fields[statusField] === 'INCOMPLETE') {
      return WsDeliverTenantStatus.Incomplete;
    } else if (tenant.fields[statusField] === 'DISABLED') {
      return WsDeliverTenantStatus.Disabled;
    } else {
      return WsDeliverTenantStatus.Ready;
    }
  } else {
    return WsDeliverTenantStatus.Ready;
  }
};




export interface WsWorkloadItem {
  id:         string;
  name:       string;
  enabled:    boolean;
  sync:       boolean;
  backup:     boolean;
  discovery:  boolean;
  compliance: boolean;
}




export const getWorkloads = (): WsWorkloadItem[] => {

  return [
    { id: 'entraid',            name: 'Microsoft Entra ID',      enabled: true,  sync: true,  backup: true,  discovery: false, compliance: false },
    { id: 'exchange',           name: 'Microsoft Exchange',      enabled: true,  sync: true,  backup: true,  discovery: false, compliance: false },
    { id: 'intune',             name: 'Microsoft Intune',        enabled: true,  sync: true,  backup: true,  discovery: false, compliance: false },
    { id: 'onedrive',           name: 'Microsoft OneDrive',      enabled: true,  sync: true,  backup: true,  discovery: false, compliance: false },
    { id: 'planner',            name: 'Microsoft Planner',       enabled: true,  sync: false, backup: false, discovery: false, compliance: false },
    { id: 'powerplatform',      name: 'Microsoft PowerPlatform', enabled: true,  sync: false, backup: false, discovery: false, compliance: false },
    { id: 'sharepoint',         name: 'Microsoft SharePoint',    enabled: true,  sync: true,  backup: true,  discovery: false, compliance: false },
    { id: 'teams',              name: 'Microsoft Teams',         enabled: true,  sync: true,  backup: true,  discovery: false, compliance: false },
    { id: 'office365',          name: 'Office 365',              enabled: true,  sync: true,  backup: true,  discovery: false, compliance: false },
    { id: 'securitycompliance', name: 'Security & Compliance',   enabled: true,  sync: true,  backup: true,  discovery: false, compliance: false },

    { id: 'viva',      name: 'Microsoft Viva',                 enabled: false, sync: false, backup: false, discovery: false, compliance: false },
    { id: 'todo',      name: 'Microsoft ToDo',                 enabled: false, sync: false, backup: false, discovery: false, compliance: false },
    { id: 'forms',     name: 'Microsoft Forms',                enabled: false, sync: false, backup: false, discovery: false, compliance: false },
    { id: 'lists',     name: 'Microsoft Lists',                enabled: false, sync: false, backup: false, discovery: false, compliance: false },
    { id: 'bookings',  name: 'Microsoft Bookings',             enabled: false, sync: false, backup: false, discovery: false, compliance: false },
    { id: 'sway',      name: 'Microsoft Sway',                 enabled: false, sync: false, backup: false, discovery: false, compliance: false },
    { id: 'stream',    name: 'Microsoft Stream',               enabled: false, sync: false, backup: false, discovery: false, compliance: false },
    { id: 'loop',      name: 'Microsoft Loop',                 enabled: false, sync: false, backup: false, discovery: false, compliance: false },
    { id: 'clipchamp', name: 'Microsoft Clipchamp',            enabled: false, sync: false, backup: false, discovery: false, compliance: false },
  ];
};




const getConfigItemType = (item: WsDeliverConfigSchemaItem) => {

  if (item.type === WsDeliverConfigItemType.Resource) {
    return 'Resource';

  } else if (item.type === WsDeliverConfigItemType.Resources) {
    return 'Resource[]';

  } else if (item.type === WsDeliverConfigItemType.Instance) {
    return 'Resource';

  } else if (item.type === WsDeliverConfigItemType.String) {
    return 'String';

  } else if (item.type === WsDeliverConfigItemType.Number) {
    return 'Number';

  } else if (item.type === WsDeliverConfigItemType.Boolean) {
    return 'Boolean';

  } else if (item.type === WsDeliverConfigItemType.ListOfResources) {
    return 'Resource[]';

  } else if (item.type === WsDeliverConfigItemType.ListOfStrings) {
    return 'String[]';

  } else {
    return '';
  }
};




const getParentPath = (path: string) => {
  const s = path.split('/');

  const x = s[s.length - 2];

  const y = path.replace(`${x}/`, '');

  return y;
};




const getResourceName = (configResourceItem: WsDeliverConfigResourceItem) => {
  return configResourceItem.instanceName ? configResourceItem.instanceName : configResourceItem.name;
};






const getResourceItemFromList = (path: string, configResourceTree: WsDeliverConfigResourceItem[]): WsDeliverConfigResourceItem | undefined => {
  let item: WsDeliverConfigResourceItem | undefined = undefined;

  configResourceTree.forEach((child: WsDeliverConfigResourceItem) => {

    if (child.path === path) {
      item = child;

    } else {

      // const found: WsDeliverConfigResourceItem | undefined = getResourceItemFromList(configResourceItem, child.children);

      // if (found) {
      //   item = found;
      // }
    }
  });

  return item;
};




export interface WsResourceDiff {
  path: string;
  source: WsDeliverConfigResourceItem | undefined;
  target: WsDeliverConfigResourceItem | undefined;
}




const getDiff = (path: string, diffList: WsResourceDiff[]) => {
  let diff = 0;

  const filter = diffList.filter((item) => item.path.startsWith(path));

  diff = filter.length;

  // const targetResourceItem = getResourceItemFromList(sourceResourceItem.path, targetResourceList);

  // if (targetResourceItem) {

  //   if (sourceResourceItem.value !== targetResourceItem.value) {
  //     // values do not match - treated as diff
  //     diff += 1;
  //   }

  //   // sourceResourceItem.children.forEach((childResourceItem: WsDeliverConfigResourceItem) => {
  //   //   diff += getDiff(childResourceItem, targetResourceItem.children);
  //   // });

  // } else {
  //   // item not found - treated as diff
  //   diff += 1;
  // }

  return diff;
};




const getDiffList = (sourceList: WsDeliverConfigResourceItem[], targetList: WsDeliverConfigResourceItem[]) => {
  const diffList: WsResourceDiff[] = [];

  sourceList.forEach((sourceItem: WsDeliverConfigResourceItem) => {

    const targetItem = targetList.find((item) => item.path === sourceItem.path);

    if (targetItem) {

      if (sourceItem.value === targetItem.value) {
        // match
      } else {
        // diff
        diffList.push({
          path: sourceItem.path,
          source: sourceItem,
          target: targetItem
        });
      }

    } else {
      // diff
      diffList.push({
        path: sourceItem.path,
        source: sourceItem,
        target: undefined
      });
    }
  });

  return diffList;
};



export const getJobTitle = (job: WsDeliverJobInterface) => {
  let text = 'Tenant Configuration';
  if (job.data.action === 'SYNC') {
    text = `Sync Tenant (${job.tenant.name})`;
  }
  if (job.data.action === 'BACKUP') {
    text = `Backup Tenant (${job.tenant.name})`;
  }
  if (job.data.action === 'CLONE') {
    text = `Clone Tenant (${job.tenant.name})`;
  }
  if (job.data.action === 'RESTORE') {
    text = `Restore Tenant (${job.tenant.name})`;
  }
  return text;
};


export const getJobStatus = (job: WsDeliverJobInterface) => {

  let text2 = 'Status...';

  if (job.data.status === 'COMPLETE') {
    text2 = 'Complete!';
  }

  if (job.data.status === 'IN_PROGRESS') {

    if ([ 'SYNC', 'BACKUP', 'CLONE', 'RESTORE' ].includes(job.data.action)) {

      const currentTask = job.data.tasks[ job.data.completed.length ];

      if (currentTask) {

        if (currentTask === 'CONTAINER') {
          text2 = 'Process started...';

        } else {
          text2 = `${getWorkloadName(currentTask)} in progress...`;
        }
      }

    } else {
      text2 = `In progress...`;
    }
  }

  return text2;
};







export {
  getDeliverApplications,
  getConfigItemType,
  getParentPath,
  getResourceName,
  getResourceItemFromList,
  getDiff,
  getDiffList
};
